var _jsxFileName = "/repo/packages/ippm/src/components/Package/index.js",
  _this = this;
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Col, Typography } from '@sm/wds-react';
import { sanitizeString } from '@sm/utils';
import { useAppContext } from '../../utils/appContext';
import { useConfiguredExperimentContext } from '../../utils/experimentContext';
import { logIPPMInteraction, trackPackageSelected } from '../../utils/logger';
import matchPaidFeaturesToTBYBFeatures from '../../utils/featuresUtil';
import { featuresMap } from '../../constants/featuresMap';
import { PLAN_TYPES, PACKAGE_IDS } from '../../constants/plans';
import Feature from '../Feature';
import FeatureSectionHeader from '../FeatureSectionHeader';
import CornerRibbon from '../CornerRibbon';
import './package.scss';
var Package = function Package(_ref) {
  var packageData = _ref.packageData,
    isRecommended = _ref.isRecommended;
  var NAVIGATE_DELAY = 100;
  var _useAppContext = useAppContext(),
    getString = _useAppContext.getString,
    displayedPlanType = _useAppContext.displayedPlanType,
    featureFlags = _useAppContext.featureFlags,
    addedPaidFeatures = _useAppContext.addedPaidFeatures,
    highlightedFeatures = _useAppContext.highlightedFeatures;
  var _useConfiguredExperim = useConfiguredExperimentContext(),
    IG_2151_ADVANTAGE_HIDE_FOOTER = _useConfiguredExperim.IG_2151_ADVANTAGE_HIDE_FOOTER,
    IG2066_COMMUNICATE_RESPONSE_LIMITS_B = _useConfiguredExperim.IG2066_COMMUNICATE_RESPONSE_LIMITS_B,
    IG2066_COMMUNICATE_RESPONSE_LIMITS_C = _useConfiguredExperim.IG2066_COMMUNICATE_RESPONSE_LIMITS_C,
    GROW_1898_STARTER_ANNUAL_V2 = _useConfiguredExperim.GROW_1898_STARTER_ANNUAL_V2,
    IG_2101_UPSELL_PAID_COLLECT = _useConfiguredExperim.IG_2101_UPSELL_PAID_COLLECT;
  var inIG2066CommunicateResponseLimitsExp = IG2066_COMMUNICATE_RESPONSE_LIMITS_B || IG2066_COMMUNICATE_RESPONSE_LIMITS_C;
  var className = classNames('package', 'package--max-width', packageData.class_name, {
    recommended: isRecommended
  });
  var showRibbon = function showRibbon() {
    return !featureFlags.isOnRbpFeatureSet;
  };
  var btnText = packageData.id !== PACKAGE_IDS.ENTERPRISE ? getString('select_plan') : getString('contact_us');
  var btnClasses = classNames('wds-button wds-button--primary wds-button--solid wds-button--md', 'header-btn wds-m-b-4 wds-m-t-3', 'stretched-88', {
    'header-btn--individual': displayedPlanType === PLAN_TYPES.INDIVIDUAL,
    'header-btn--teams-enterprise': packageData.id === PACKAGE_IDS.ENTERPRISE,
    'header-btn--teams-annual': displayedPlanType === PLAN_TYPES.TEAMS && packageData.id !== PACKAGE_IDS.ENTERPRISE
  });
  var renderHeader = function renderHeader() {
    var renderPackageLabel = function renderPackageLabel() {
      if (featureFlags.standardMonthly500 && packageData.id === PACKAGE_IDS.STANDARD_MONTHLY) {
        // Return updated plan name for Standard Monthly in RBP experiment
        return getString('ig_1677_standard_monthly_name');
      }
      return packageData.package_label;
    };
    var renderPerMonthText = function renderPerMonthText() {
      return /*#__PURE__*/React.createElement(Typography, {
        variant: "bodySm",
        className: "font-size-14 header-frequency font-weight-light",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 76,
          columnNumber: 9
        }
      }, packageData.per_month_message);
    };
    var renderBillingFrequencyText = function renderBillingFrequencyText() {
      var billingFrequencyTextClasses = classNames('font-size-14', 'font-weight-light', {
        'wds-m-t-4': displayedPlanType === PLAN_TYPES.TEAMS && packageData.id !== PACKAGE_IDS.ENTERPRISE
      });
      return /*#__PURE__*/React.createElement(Typography, {
        variant: "bodySm",
        className: billingFrequencyTextClasses,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 96,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: sanitizeString(packageData.billing_frequency)
        },
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 97,
          columnNumber: 11
        }
      }));
    };
    return /*#__PURE__*/React.createElement("header", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 107,
        columnNumber: 7
      }
    }, packageData.is_audience && /*#__PURE__*/React.createElement(Typography, {
      variant: "bodySm",
      className: "audience-header font-weight-medium",
      component: "strong",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 109,
        columnNumber: 11
      }
    }, getString('audience_header')), /*#__PURE__*/React.createElement(Typography, {
      className: "wds-m-t-5 header-label",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 117,
        columnNumber: 9
      }
    }, renderPackageLabel()), /*#__PURE__*/React.createElement(Typography, {
      variant: "hero2",
      className: "header-cost wds-m-t-1 wds-m-b-2",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 120,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: sanitizeString(packageData.cost)
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 121,
        columnNumber: 11
      }
    })), packageData.id !== PACKAGE_IDS.ENTERPRISE && renderPerMonthText(), packageData.id !== PACKAGE_IDS.ENTERPRISE && renderBillingFrequencyText(), /*#__PURE__*/React.createElement("a", {
      className: btnClasses,
      href: packageData.upgrade_link,
      target: "_parent",
      onClick: function onClick(evt) {
        logIPPMInteraction('package_select', 'package_cta', packageData.id);
        trackPackageSelected(packageData, isRecommended);
        // introduce a tiny delay so tracking can get sent
        evt.preventDefault();
        setTimeout(function () {
          window.location.href = packageData.upgrade_link;
        }, NAVIGATE_DELAY);
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 130,
        columnNumber: 9
      }
    }, btnText));
  };
  var renderFeatureList = function renderFeatureList(features) {
    return /*#__PURE__*/React.createElement("ul", {
      className: "feature-list",
      key: features.length,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 152,
        columnNumber: 7
      }
    }, features.map(function (_ref2) {
      var name = _ref2.name,
        label = _ref2.label,
        included = _ref2.included;
      return /*#__PURE__*/React.createElement(Feature, {
        key: name,
        label: label,
        included: included,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 154,
          columnNumber: 11
        }
      });
    }));
  };
  var shouldRenderPaidFeatureSection = ![PACKAGE_IDS.ENTERPRISE, PACKAGE_IDS.TEAMS_ADVANTAGE, PACKAGE_IDS.TEAMS_PREMIER].includes(packageData.id) && (addedPaidFeatures === null || addedPaidFeatures === void 0 ? void 0 : addedPaidFeatures.length) > 0;
  var renderPaidFeatureSection = function renderPaidFeatureSection() {
    var packageFeatures = packageData.features;
    var matchedTBYBFeatures = matchPaidFeaturesToTBYBFeatures(addedPaidFeatures);
    var features;
    if (packageData.id === PACKAGE_IDS.ADVANTAGE && IG_2151_ADVANTAGE_HIDE_FOOTER) {
      features = matchedTBYBFeatures.map(function (name) {
        return {
          name: name,
          label: packageFeatures[name].label,
          included: name === 'create_toggle_footer_enabled' ? true : packageFeatures[name].included
        };
      });
    } else {
      features = matchedTBYBFeatures.map(function (name) {
        return {
          name: name,
          label: packageFeatures[name].label,
          included: packageFeatures[name].included
        };
      });
    }
    return /*#__PURE__*/React.createElement("section", {
      className: "added-features",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 193,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(FeatureSectionHeader, {
      className: "added-features__header",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 194,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement("span", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 195,
        columnNumber: 11
      }
    }, getString('paid_features_in_your'))), renderFeatureList(features));
  };
  var renderAllFeatures = function renderAllFeatures() {
    var isIndividualPlan = [36, 34, 31, 32].includes(packageData.id);
    var chooseDefaultFeatures = function chooseDefaultFeatures() {
      if (inIG2066CommunicateResponseLimitsExp) {
        return packageData.communicate_response_limit_features;
      }
      // Begin GROW-1898
      if (GROW_1898_STARTER_ANNUAL_V2) {
        return packageData.grow_starter_annual;
      }
      // End GROW-1898
      return packageData.default_features;
    };
    var shouldRenderHighlightedFeatures = isIndividualPlan && highlightedFeatures;
    var packageLabel = function packageLabel() {
      var includedInLabel = getString('included_in').replace('{label}', packageData.package_label);
      var alsoIncludedInLabel = getString('also_included_in').replace('{label}', packageData.package_label);
      if (!shouldRenderHighlightedFeatures && (!shouldRenderPaidFeatureSection || !addedPaidFeatures)) {
        return includedInLabel;
      }
      return alsoIncludedInLabel;
    };
    var renderHighlightedFeatures = function renderHighlightedFeatures() {
      var matchedFeatures = [];
      highlightedFeatures.forEach(function (key) {
        if (featuresMap[key]) {
          matchedFeatures.push(key);
        }
      });
      var features = matchedFeatures.map(function (name) {
        return {
          name: name,
          label: featuresMap[name].label,
          included: true
        };
      });
      return features.length > 0 ? [/*#__PURE__*/React.createElement(FeatureSectionHeader, {
        customHeader: true,
        className: "wds-p-t-3",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 249,
          columnNumber: 11
        },
        key: "0"
      }, "Plan highlight"), renderFeatureList(features)] : null;
    };
    var renderFeaturedResponses = function renderFeaturedResponses() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FeatureSectionHeader, {
        customHeader: true,
        className: "wds-p-t-3",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 261,
          columnNumber: 11
        }
      }, getString('responses_header')), /*#__PURE__*/React.createElement("ul", {
        className: "feature-list",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 264,
          columnNumber: 11
        }
      }, chooseDefaultFeatures().map(function (f) {
        var key = Object.keys(f)[0];
        if (key === 'number_of_response') {
          return /*#__PURE__*/React.createElement(Feature, {
            key: key,
            label: f[key].label,
            included: f[key].included,
            customFeature: true,
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 269,
              columnNumber: 19
            }
          });
        }
        return null;
      })), /*#__PURE__*/React.createElement("hr", {
        className: "highlighted-feature__break wds-m-l-4 wds-m-r-4",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 280,
          columnNumber: 11
        }
      }));
    };
    return /*#__PURE__*/React.createElement("section", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 286,
        columnNumber: 7
      }
    }, shouldRenderHighlightedFeatures && renderHighlightedFeatures(), isIndividualPlan && !inIG2066CommunicateResponseLimitsExp && IG_2101_UPSELL_PAID_COLLECT && renderFeaturedResponses(), /*#__PURE__*/React.createElement(FeatureSectionHeader, {
      className: "wds-p-t-4",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 292,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: sanitizeString(packageLabel())
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 293,
        columnNumber: 11
      }
    })), /*#__PURE__*/React.createElement("ul", {
      className: "feature-list",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 297,
        columnNumber: 9
      }
    }, chooseDefaultFeatures().map(function (f) {
      var key = Object.keys(f)[0];
      if (highlightedFeatures && highlightedFeatures.includes(key)) {
        return null;
      }
      if (key === 'number_of_response' && IG_2101_UPSELL_PAID_COLLECT) {
        return null;
      }
      return /*#__PURE__*/React.createElement(Feature, {
        key: key,
        label: f[key].label,
        included: f[key].included,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 307,
          columnNumber: 15
        }
      });
    })));
  };
  return /*#__PURE__*/React.createElement(Col, {
    className: className
    // for metrics purposes since teasing some of this information out
    // of the raw data is tricky at best, especially for the
    // recommended package
    ,

    "data-package-name": packageData.class_name,
    "data-package-id": packageData.id,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 320,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("section", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 328,
      columnNumber: 7
    }
  }, showRibbon() && /*#__PURE__*/React.createElement(CornerRibbon, {
    packageData: packageData,
    isRecommended: isRecommended,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 330,
      columnNumber: 11
    }
  }), renderHeader(), /*#__PURE__*/React.createElement("main", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 336,
      columnNumber: 9
    }
  }, shouldRenderPaidFeatureSection && renderPaidFeatureSection(), renderAllFeatures())));
};
Package.defaultProps = {};
Package.propTypes = {
  packageData: PropTypes.shape({
    class_name: PropTypes.string.isRequired,
    upgrade_link: PropTypes.string.isRequired,
    cost: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    is_audience: PropTypes.bool,
    package_label: PropTypes.string,
    per_month_message: PropTypes.string,
    billing_frequency: PropTypes.string,
    features: PropTypes.shape().isRequired,
    grow_starter_annual: PropTypes.arrayOf(PropTypes.shape),
    communicate_response_limit_features: PropTypes.arrayOf(PropTypes.shape),
    default_features: PropTypes.arrayOf(PropTypes.shape)
  }).isRequired,
  isRecommended: PropTypes.bool.isRequired
};
export default Package;